module.exports = __webpack_public_path__ + "static/img/repair.38c83e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/repair.jpg
// module id = AmtG
// module chunks = 1